import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Section = styled.section`
  margin-top: 28px;
`

const Card = styled.div`
  padding: 20px 22px 18px;
  background: ${p => p.theme.colors.semantic.surface};
  border: 1px solid ${p => p.theme.colors.semantic.border};
  border-radius: 12px;
  box-shadow: ${p => p.theme.colors.semantic.shadowSm};
`

const SectionHead = styled.div`
  margin-bottom: 4px;
`

const SectionTitle = styled.span`
  font-family: ${p => p.theme.fontFamily.sans.join(', ')};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${p => p.theme.colors.semantic.textPrimary};
`

const SectionSub = styled.span`
  display: block;
  font-size: 12px;
  color: ${p => p.theme.colors.semantic.textMuted};
  margin-top: 4px;
`

const Timeline = styled.div`
  position: relative;
  margin-top: 12px;
  padding-top: 20px;
`

const Axis = styled.div`
  position: relative;
  height: 2px;
  background: ${p => p.theme.colors.semantic.border};
  border-radius: 2px;
`

const TodayLine = styled.div`
  position: absolute;
  top: -6px;
  bottom: -6px;
  width: 2px;
  background: ${p => p.theme.colors.semantic.accent};
  left: ${p => p.$left};
`

const TodayLbl = styled.div`
  position: absolute;
  top: -20px;
  transform: translateX(-50%);
  font-family: ${p => p.theme.fontFamily.sans.join(', ')};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: ${p => p.theme.colors.semantic.accent};
  text-transform: uppercase;
  white-space: nowrap;
  left: ${p => p.$left};
`

const KdItem = styled.div`
  position: absolute;
  top: -5px;
  transform: translateX(-50%);
  left: ${p => p.$left};
`

const Pin = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${p => p.theme.colors.semantic.surface};
  border: 2px solid ${p => p.$border};
  margin: 0 auto;
`

const Lab = styled.div`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  white-space: nowrap;
  font-size: 11px;
`

const LabN = styled.span`
  font-weight: 600;
  display: block;
  margin-bottom: 2px;
  color: ${p => (p.$muted ? '#676767' : '#050519')};
`

const LabD = styled.span`
  color: ${p => p.theme.colors.semantic.textMuted};
  font-family: ${p => p.theme.fontFamily.sans.join(', ')};
  font-size: 10px;
`

const Months = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${p => p.theme.fontFamily.sans.join(', ')};
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${p => p.theme.colors.semantic.textMuted};
  font-weight: 700;
  margin-top: 64px;
  padding-top: 10px;
  border-top: 1px dashed ${p => p.theme.colors.semantic.border};
`

const WipAiKeyDatesTimeline = ({ keyDates, today }) => {
  const t = new Date(today)
  const min = new Date('2026-04-01')
  const max = new Date('2026-06-15')
  const range = max - min
  const pos = d => ((d - min) / range) * 100

  return (
    <Section id="keydates">
      <Card>
        <SectionHead>
          <SectionTitle>Key Dates</SectionTitle>
          <SectionSub>Projected case schedule</SectionSub>
        </SectionHead>
        <Timeline>
          <Axis>
            <TodayLine $left={`${pos(t)}%`} />
            <TodayLbl $left={`${pos(t)}%`}>Today</TodayLbl>
            {keyDates.map((kd, i) => {
              const d = new Date(kd.StartDate__c)
              const past = d < t
              return (
                <KdItem key={i} $left={`${pos(d)}%`}>
                  <Pin $border={past ? '#D0D0D0' : '#4241BF'} />
                  <Lab>
                    <LabN $muted={past}>{kd.Name}</LabN>
                    <LabD>{d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</LabD>
                  </Lab>
                </KdItem>
              )
            })}
          </Axis>
          <Months>
            <span>Apr</span>
            <span>May</span>
            <span>Jun</span>
          </Months>
        </Timeline>
      </Card>
    </Section>
  )
}

WipAiKeyDatesTimeline.propTypes = {
  keyDates: PropTypes.arrayOf(PropTypes.object).isRequired,
  today: PropTypes.string.isRequired,
}

export default WipAiKeyDatesTimeline
